module.exports = __webpack_public_path__ + "static/img/third3_1_3_active.7bf0ca16.jpg";